import { Chip, styled, Tab, Tabs } from '@mui/material';
import React from 'react';

const TAB_LIST = [
    {
        label: 'Item One',
        value: 'one',
    },
    {
        label: 'Item two',
        value: 'two',
    },
    {
        label: 'Item three',
        value: 'three',
    },
];

export const StyledTabs = styled(Tabs)(({ theme }) => ({
    '& .MuiButtonBase-root.MuiTab-root': {
        color: theme.palette.text.primary,
        textTransform: 'capitalize',

        fontSize: theme.typography.customFontSize.small,
        fontWeight: theme.typography.fontWeightSemiBold,

        minHeight: '48px',
    },

    '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
        color: theme.palette.primary.main,
    },

    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.primary.main,
    },
}));

function CustomTabs({
    selectedValue = undefined,
    onSelectedValueChange = null,
    tabList = null,
    ariaLabel = 'Business Documents Tabs',
    ...props
}) {
    const [value, setValue] = React.useState('one');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const currentTabList = tabList || TAB_LIST;
    return (
        <StyledTabs
            value={selectedValue || value}
            onChange={onSelectedValueChange || handleChange}
            aria-label={ariaLabel}
            {...props}
        >
            {currentTabList.map((cTab, index) => (
                <Tab
                    key={index}
                    value={cTab.value}
                    label={cTab.label}
                    icon={cTab.status ? <Chip label={cTab.status || 'Outsource'} /> : null}
                    iconPosition="end"
                />
            ))}
        </StyledTabs>
    );
}

// CustomTabs Component
/**
 * CustomTabs
 *
 * A tab component for displaying a set of tabs with optional icons and custom labels.
 * Includes default tabs if no custom list is provided and handles both controlled and uncontrolled selection.
 *
 * @param {Object} props - Component props
 * @param {string} props.selectedValue - Currently selected tab value (for controlled component).
 * @param {function} props.onSelectedValueChange - Callback function for tab change events.
 * @param {Array} props.tabList - List of tabs with `label`, `value`, and optional `status` properties.
 * @param {string} props.ariaLabel - Accessibility label for the Tabs component.
 *
 * @returns {JSX.Element} - A customized Tabs component.
 */
export default CustomTabs;
